<template>
    <div class="row">
        <hr>
        <div class="col-10 offset-1">
        <div class="featured-boxes featured-boxes-style-6">
            <div class="row">
                <div class="col" v-for="el in elements" :key="el.icon">
                    <div class="featured-box featured-box-primary featured-box-effect-6" style="height: 150px;margin-top: 10px !important; margin-bottom: 10px !important;">
                        <div class="box-content" style="padding-left: 0px !important; padding-right: 0px !important;">
                            <i :class="`icon-featured ${el.icon}`" style="margin-left: 0px !important; margin-right: 0px !important;"></i>
                            <h4 v-html="computeText(el.name, el.additional)" class="title" style="color: #474A57; font-family: 'Open Sans', sans-serif !important; font-weight: 500 !important; white-space: nowrap;"></h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'IconProperties',
    methods: {
        computeText: function(name, additional) {
            if (additional !== undefined) {
                return name + additional;
            }
            return name;
        } 
    },
    props: {
        elements: {
            type: Array,
            default: function() {
                return [
                    {
                        icon: "fas fa-home",
                        name: "TypeOfHouse"
                    },
                    {
                        icon: "fas fa-users",
                        name: "NumberOfPeople"
                    },
                    {
                        icon: "fas fa-vector-square",
                        name: "Surface",
                        additional: " m<sup>2</sup>"
                    },
                    {
                        icon: "fas fa-bath",
                        name: "Bathrooms"
                    }
                ];
            }
        }
    },
}
</script>

<style scoped>

</style>